import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
  Select,
  InputLabel,
  Autocomplete,
  Button,
  Box
} from "@mui/material";
import React, { useState, useRef, useEffect, useContext, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SectionHeader } from "../Forms/SectionHeader";
import CommonGrid from "../../Repository/CommonGrid";
import { VARIABLE_COLLECTION } from "../../../constants/loopRecordOptions";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FieldTypeByte from "./FieldTypeByte";
import { ConstantValueControl } from "../Forms/OutboundFieldFormattingOptions/ConstantValueControl";
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep, debounce, isEmpty } from "lodash";
import { treeActions } from "../../../redux/slices/treeSlice";
import SourceType from "../../TemplateProperties/SourceType";
import { getNodesByIcon } from "../../../utils/utilFunctions";
import VariableActionCountRenderer from "./VariableActionCountRenderer";
import VariableActionSortRenderer from "./VariableActionSortRenderer";
import DelimiterDialog from "../../TemplateProperties/DelimiterDialog";
import WorkflowSessionModal1 from "../WorkflowSessionModal1";
import FormattingOptions from "../Forms/FormattingOptions";
import { dateIntervalDropDown } from "../../../constants/constantList";
import LightTooltip from "../../../commonComponents/LightTooltip";
import ResizableBox from "../../Common/ResizableBox";

function OutboundVariableCollectionProperties() {
  const { t } = useTranslation();

  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const currentTab = rightTree.currentTab;
  const { translatedData, selectedNode } = rightTree.tree[rightTree.currentTab];
  const dispatch = useDispatch();

  const [variableName, setVariableName] = useState("");
  const [variableNameOptions,setVariableNameOptions] = useState([])
  const [initialValue, setInitialValue] = useState("");
  const [workflowSession, setWorkflowSession] = useState(false);
  const [workflowSessionValue, setWorkflowSessionValue] = useState("");
  const [applyToFldProperties, setApplyToFldProperties] = useState(false);
  const [variableAction, setVariableAction] = useState("");
  const [indexOption, setIndexOption] = useState("CURRENT");
  const [delimiterValue, setDelimiterValue] = useState("");
  const [delimiterOptions, setDelimiterOptions] = useState([t("EMPTY_COMBO")]);
  const [variableValue, setVariableValue] = useState("");
  const [variableActionOptionsDropdown,seVariableActionOptionsDropdown] = useState([])
  const [sessionItemValue, setSessionItemValue] = useState('');
  const [fieldType,setFieldType] = useState("");
  const [openDelimiterModal,setOpenDelimiterModal] = useState(false)
  const [openWorkflowSessionModal,setOpenWorkflowSessionModal] = useState(false)
	const [actionselectedNode, setActionSelectedNode] = useState({});

  const [variableOptions, setVariableOptions] = useState(["--Select--"]);
  const [sessionItemOptions, setSessionItemOptions] = useState(["-- Empty --"])
  const [constantValue, setConstantValue] = useState("");
  const [ignoreCase,setIgnoreCase] = useState(false)
  const [rowData,setRowData] = useState([])
  const [gridApi,setGridApi] = useState(null)

  const [repeatNumValue,setRepeatNumValue] = useState('1')
  const [dateInterval, showDateInterval] = useState(false);
	const [dateIntervalValue, setDateIntervalValue] = useState('');
  const constantValueInitial = selectedNode?.VALUE ? selectedNode?.VALUE : "";
  let constantValueOptions = ["", t('CRLF'), t('RECORD_DELIMITER')];
  if (constantValueInitial) constantValueOptions.push((constantValueInitial));
  
  const onGridReady = (params) => {
    params.api.sizeColumnsToFit();
    setGridApi(params.api)    
  };

  const CustomCellRenderer = (info) => {
    const { value,api,data } = info;
    
    const handleCopyAction = (e) => {
      const selectedNode = data;
      api.forEachNode((node) => {
        node.setSelected(node === selectedNode);
      }); 
      setTimeout(()=>{
        const actionData = [];
        const selectedRows = api.getSelectedRows();
        api.forEachNode((node) => {
          actionData.push(node.data);
        });
        actionData.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, selectedRows?.[0]);
        variableActionsHandler([...actionData], +selectedRows?.[0]?.id + 1, api);
        submitHandler("ACTIONS", removeInternalProperties(actionData));
      },100)     
    
    };

   const handleDeleteAction = (e, rowData) => {
    const deleteAndUpdateIds = (array, index) => {
      // Remove the element at the specified index
      array.splice(index, 1);
    
      // Update the IDs of the remaining elements
      for (let i = index; i < array.length; i++) {
        array[i].id--; 
      }
    
      return array;
    };
    let rows = [];
    api.forEachNode((node) => {
      rows.push(node.data);
    });
    const index = rowData.id;
    const updatedRows = deleteAndUpdateIds(rows,index)
    api.setGridOption('rowData', updatedRows)
    variableActionsHandler(updatedRows,0,api)
		submitHandler("ACTIONS", removeInternalProperties(updatedRows));
  };
  

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: '2rem',
        }}
      >
       
        <div className='truncated-text' title={value}>{value}</div>
        {data?.key || data?.ACTION ? (
          <div className="flex align-center">
            <LightTooltip
              title={'Copy Action'}
              arrow>
              <span style={{ cursor: 'pointer' }} className="FILE_COPY" onClick={(e) => handleCopyAction(e,data)} ></span>
            </LightTooltip>
            <LightTooltip
              title={'Delete Action'}
              arrow>
              <span style={{ cursor: 'pointer' }} className="DELETE_MUI" onClick={(e) => handleDeleteAction(e,data)} ></span>
            </LightTooltip>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };
  
  const customClickHandlerOnAdd = (e) => {
		const data = [];
		const selectedRows = e.api.getSelectedRows();
		e.api.forEachNode((node) => {
			data.push(node.data);
		})
    const newAction = {
      TYPE:'VARIABLE_COLLECTION',
      NAME: selectedNode.NAME
    }
		data.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, {
      ...newAction,
      ACTION: data?.length ? "CONCATENATE" : "SET",
    });
		variableActionsHandler(
      [...data],
      data.length && selectedRows?.length ? +selectedRows?.[0]?.id + 1 : 0,
      e.api
    );
		submitHandler("ACTIONS", removeInternalProperties(data));
	}
  
  
  const gridOptions = useMemo(()=> {
    return {
      columnDefs: [
        {
          addNewControl: true,
          addControlLabel: t("HOVER_MSSG_ADD_VARIABLE_ACTION"),
          headerName: t("LBL_VAR_ACTIONS"),
          field: "key",
          editable: false,
          resizable: false,
          cellRenderer: (info) => CustomCellRenderer(info),
          customClickHandlerOnAdd: customClickHandlerOnAdd,
          rowDrag: true,
        },
      ],

      onRowDragEnter: function (event) {
        const selectedNode = event.node;
        event.api.forEachNode((node) => {
          node.setSelected(node === selectedNode);
        });
      },

      onRowDragEnd: function (event) {
        // Handle row drag end event here
        const newRowData = [];
        const selectedNodes = event.api.getSelectedRows();
        let newSelectedId = null;
        event.api.forEachNodeAfterFilterAndSort(function (node, i) {
          newRowData.push({ ...node.data, id: i });
          if (selectedNodes[0]?.id === node.data.id) newSelectedId = i;
        });
        // Remove internal properties before saving to JSON
        submitHandler("ACTIONS", removeInternalProperties(newRowData));
        event.ap.setGridOption('rowData', newRowData)
        if (newSelectedId !== null)
          variableActionsHandler(newRowData, newSelectedId, event.api);
      },
      rowDragManaged: true,
    };
}, [selectedNode?.key]);

  const handleRowClicked = (event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes.length === 0 || !selectedNodes.find(node => node.id === event.node.id)) {
        event.node.setSelected(true);
        setActionSelectedNode(event.node.data)
    }
};
  const dateIntervalOptions = dateIntervalDropDown.map((e, i) => {
		return (
			<MenuItem key={"dateInterval" + i} value={e?.value}>
				{t(e?.text)}
			</MenuItem>
		);
	});
  const setVariableActionDropdownItems = (variableAction) => {
    if(!gridApi) return;
    // collect previous nodes
    const nodes = [];
    gridApi.forEachNode((node) => {
      if (Number(variableAction?.id) > Number(node?.data?.id)) {
				nodes.push(node.data);
			}
    })
    let newOptions = [];
		let supportedAction = [];
    nodes.forEach((e) => {
      if(e?.FIELDTYPE === 'DATE') {
        supportedAction = VARIABLE_COLLECTION.filteredVariableAction.map((e) => e?.value)
        if (
					["CONSTANT", "INTEGER", "DATE"].includes(actionselectedNode?.FIELDTYPE)
				)
					showDateInterval(true);
				return;
      } else {
        supportedAction = VARIABLE_COLLECTION.variableAction.map((e) => e?.value)
        showDateInterval(false)
        return;
      }
    })
    if (!nodes?.length) {
			supportedAction = VARIABLE_COLLECTION.variableAction.map((e) => e?.value);
			showDateInterval(false);
		}
		newOptions = VARIABLE_COLLECTION.variableAction.filter((e) => {
			return supportedAction.includes(e?.value);
		});
		seVariableActionOptionsDropdown(
			newOptions.map((e, i) => {
				return (
					<MenuItem key={i} value={e.value}>
						{t(e.title)}
					</MenuItem>
				);
			})
		);
  }
  const indexOptionsDropdown = VARIABLE_COLLECTION.index.map((obj, index) => {
    return (
      <MenuItem key={index} value={obj.value}>
        {obj.title}
      </MenuItem>
    );
  });
  const removeInternalProperties = (data) => {
		const cleanedData = data.map((e) => {
			const cleaned = { ...e };
			// Remove internal UI properties that shouldn't be saved to JSON
			if (cleaned?.hasOwnProperty("id")) delete cleaned.id;
			if (cleaned?.hasOwnProperty("key")) delete cleaned.key;
			if (cleaned?.hasOwnProperty("isDateMapped")) delete cleaned.isDateMapped;
			if (cleaned?.hasOwnProperty("inboundPattern")) delete cleaned.inboundPattern;
      if (cleaned?.hasOwnProperty("INBOUND_PATTERN")) delete cleaned.INBOUND_PATTERN;
			return cleaned;
		});
		return cleanedData;
	};

  const submitHandler = (key, value, valuesObj) => {
    const updatedData = eachDeep(cloneDeep(translatedData), (obj) => {
      if (obj?.key !== selectedNode.key) {
        return;
      }
        if (!key) {
          Object.keys(valuesObj).forEach((e) => {
            obj[e] = valuesObj[e];
          });
        } else {
          if (key === "ACTIONS"){
            const sanitizeData = removeInternalProperties(value)
            obj.VARIABLE = sanitizeData;
          } 
          else if (key === "NAME") {
            obj[key] = value;
            obj.title = `${t("VARIABLE_COLL")} ${
              value ? value : variableNameOptions[0]
            }`;
            obj?.VARIABLE.map((item) => {
              item[key] = value
            })
          } else if (key === "START_VALUE" || key === 'FORMAT_WFSESSION_VAR' || key === 'WF_SESSION_NAME') {
            obj?.VARIABLE.map((item) => {
              item[key] = value === true ? 'TRUE' :value;
              return item;
            });
            if(key === 'WF_SESSION_NAME' && value === "") 
              obj?.VARIABLE.forEach((item) => {
                delete item[key]
              })
          } 
           else obj[key] = value;
        }
        dispatch(
          treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: rightTree.currentTab,
            data: obj,
          })
        );
    });
    dispatch(
      treeActions.setRightTreeTransData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );
  };
  const submitActionHandler = (key, value, bulk, removeValues) => {
		const nodes = [];
		if (gridApi) {
			gridApi.forEachNode((node) => {
				const tempNode = cloneDeep(node.data);
				if (actionselectedNode?.id === node.data.id) {
					if (key) {
						tempNode[key] = value;
					} else {
						Object.keys(bulk).forEach((e) => {
							tempNode[e] = bulk[e];
						});
					}
					if (removeValues?.length) {
						removeValues.forEach((e) => {
							if (tempNode?.hasOwnProperty(e)) delete tempNode[e];
						});
					}
					setActionSelectedNode(tempNode);
				}
				nodes.push(tempNode);
			});
		}
		variableActionsHandler(nodes, actionselectedNode.id, gridApi);
		submitHandler("VARIABLE", removeInternalProperties(nodes));
	};
  const variableActionsHandler = (data = [], selectionIndex, gridAPI) => {
		if (!gridAPI){
     setRowData([]);
     return;
    } 
		const rowData = data?.map((e, i) => {
			let title = `${e?.ACTION}-`;
      if (e?.FIELDTYPE === "CONSTANT" || e?.FIELDTYPE === "BIT_FLAG")
        title += `"${e?.VALUE || ""}"`;
      else if (e?.RECORD_TYPE && e?.MAPNAME)
        title += `${e?.RECORD_TYPE}/${e?.MAPNAME}`;
			return {
				...e,
				key: title,
				id: i,
			};
		});
		gridAPI.setGridOption('rowData', rowData)
		setTimeout(() => {
			gridAPI.forEachNode((node) => {
				if (node?.data?.id === selectionIndex) {
					node.setSelected(true);
					setActionSelectedNode(node.data);
					gridAPI.ensureNodeVisible(node);
				}
			});
      if(!rowData.length) setActionSelectedNode({})
		}, 100);
	};
  const actionUpdater = (key, value, valuesObj) => {
    const rows = [];
    if(gridApi){
      gridApi.forEachNode((node) => {
        const row = cloneDeep(node.data);
        if(actionselectedNode.id === node.data.id){
          if (key) {
            if (key === "SET_INDEX") {
              delete row["SET_INDEXTYPE"];
            }

            row[key] = value;
          } else {
            Object.keys(valuesObj).forEach((e) => {
              row[e] = valuesObj[e];
              // if(valuesObj.VALUE) row.key = `${row?.ACTION}-` + valuesObj[e]
            });
          }
          setActionSelectedNode(row)
        }
        rows.push(row)
        
      })
    }
    variableActionsHandler(rows, actionselectedNode.id, gridApi);
    submitHandler("ACTIONS", removeInternalProperties(rows))
  }
  const handleVaribleActionChange = (e) => {
    setVariableAction(e.target.value);
    setFieldType("SELECT");
    setIndexOption("CURRENT")
    // actionUpdater("ACTION",e.target.value)
    if (
      // actionsWithFieldTypes.includes(variableAction) &&
      (!actionsWithFieldTypes.includes(e.target.value) || actionWithoutControl.includes(e.target.value))
    ) {
      debounceActionHandler("ACTION", e.target.value, null, ["FIELDTYPE"]);
    } else {
      debounceActionHandler("ACTION", e.target.value);
    }
  };
  const extractVariableNames = useMemo(() => {
    return (data) => {
      const names = [];

      const extractNames = (obj) => {
        if (obj.TYPE === "VARIABLE" && obj.NAME) {
          names.push(obj.NAME);
        }

        if (obj.children && obj.children.length > 0) {
          obj.children.forEach(extractNames);
        }
      };

      data.forEach(extractNames);
      return ["--Select--", ...names];
    };
  }, [translatedData]);
 
  const variableNameDropDownHandler = (variableNodes) => {
		const uniqueNodes = [];
		variableNodes?.forEach((e) =>
			!uniqueNodes?.includes(e?.NAME) ? uniqueNodes.push(e?.NAME) : null
		);
		const menuItems = uniqueNodes?.map((e, i) => {
			return e;
		});
		setVariableNameOptions(menuItems);
	};
  const handleRepeatTimesChange = (value) => {
    const validateInput = (value) => {
      const regex = /^(\d{1,9})?$/;
      return regex.test(value);
    };
    const valid = validateInput(value)
    if(valid){
      setRepeatNumValue(value)
      debounceActionHandler("REPEAT",value);
    }
  }
  useEffect(() => {
    if (translatedData && indexOption === "VARIABLE") {
      const options = extractVariableNames(translatedData).map(
        (option, index) => ({ label: option, key: `${option}_${index}` })
      );
      setVariableOptions(options);
    }
  }, [translatedData, indexOption]);

 
  useEffect(() => {
    const bodyVariableCollectionNodes = getNodesByIcon(
			rightTree?.tree?.["body"]?.translatedData,
			["VARIABLE_COLLECTION"]
		);
		const headerVariableCollectionNodes = getNodesByIcon(
			rightTree?.tree?.["header"]?.translatedData,
			["VARIABLE_COLLECTION"]
		);
		const trailerVariableCollectionNodes =
			currentTab === "trailer"
				? getNodesByIcon(rightTree?.tree?.["trailer"]?.translatedData, [
						"VARIABLE_COLLECTION",
				  ])
				: [];
		variableNameDropDownHandler([
			...bodyVariableCollectionNodes,
			...headerVariableCollectionNodes,
			...trailerVariableCollectionNodes,
		]);
    setVariableName(selectedNode.NAME || "");
    setInitialValue(selectedNode?.VARIABLE?.[0]?.START_VALUE ?? "");
    setApplyToFldProperties(selectedNode?.VARIABLE?.[0]?.FORMAT_WFSESSION_VAR === 'TRUE' ?? false)
    setWorkflowSession(!!selectedNode?.VARIABLE?.[0]?.WF_SESSION_NAME);
    setWorkflowSessionValue(selectedNode?.VARIABLE?.[0]?.WF_SESSION_NAME ?? "");
    const actions = selectedNode?.VARIABLE || [];
    variableActionsHandler(actions, 0, gridApi);
  
  }, [selectedNode?.key, gridApi, currentTab]);
  
  useEffect(() => {
		return () => {
			setActionSelectedNode({});
		};
	}, [selectedNode?.key, currentTab]);

  useEffect(() => {
    if (actionselectedNode) {
      const { ACTION, FIELDTYPE, SET_INDEX, SET_INDEXTYPE,IGNORE_CASE } = actionselectedNode;
      setVariableAction(ACTION || "");
      setFieldType(
        fieldTypeOptions[ACTION]?.includes(FIELDTYPE)
          ? FIELDTYPE
          : fieldTypeOptions["OTHERS"].includes(FIELDTYPE)
          ? FIELDTYPE
          : "SELECT"
      );
      setIndexOption(SET_INDEX || "CURRENT");
      setDelimiterValue(SET_INDEXTYPE || "");
      setVariableValue(SET_INDEXTYPE || "");
      setVariableActionDropdownItems(actionselectedNode)
      setDateIntervalValue(actionselectedNode?.UNIT || 'DAY')
      setRepeatNumValue(actionselectedNode.REPEAT || "1")
      setSessionItemValue(SET_INDEXTYPE || '')
      setIgnoreCase(IGNORE_CASE === 'TRUE' || false)
      setConstantValue(actionselectedNode?.VALUE || constantValueInitial)
    }
  }, [actionselectedNode?.id]);
  
  
  const debounceChangeHandler = useCallback(debounce(submitHandler, 400), [
		rightTree.currentTab,
		rightTree.tree,
		rightTree.tree[rightTree.currentTab].translatedData,
	]);
  
  const debounceActionHandler = useCallback(
		debounce(submitActionHandler, 400),
		[
			rightTree.currentTab,
			rightTree.tree,
			rightTree.tree[rightTree.currentTab].translatedData,
			actionselectedNode,
		]
	);
  const handleDelimiterModalState = () =>{
    setOpenDelimiterModal(true)
  }
  const delimDisplay = (val, modal) => {
    if(val === undefined) return '';
    if (!modal) {
      if (typeof val === 'boolean'|| val === t('TXT_NO_DELIM_CHOSEN') || !val) return t('TXT_NO_DELIM_CHOSEN');
    }
    if (val === "CR" || val === "%0D" || val === "\r") return "CR";
    if (val === "LF" || val === "%0A" || val === "\n" ) return "LF";
    if (val === "CRLF" || val === "%0D%0A") return "CRLF";
    const crlfIndex = val.indexOf('%0D%0A');
    if (crlfIndex !== -1) {
      // Handle the case where val includes %0D%0A(CRLF)
      const beforeCRLF = decodeURIComponent(val.substring(0, crlfIndex));
      const afterCRLF = decodeURIComponent(val.substring(crlfIndex + 6));
      return beforeCRLF + 'CRLF' + afterCRLF;
    }
    try { val = decodeURIComponent(val) } 
    catch (e) {
      console.log(e) 
    }
    return val;
  }
  const handleDelimitedInput = (val) => {
    if (val) {
      const newDelimVal = delimDisplay(val, true)
      setDelimiterValue(delimDisplay(newDelimVal, true))
    } else setDelimiterValue(val, true)
  }
  const sourceTypeValuesHandler = (values, sourceType) => {
    
    const valuesCopy = { ...values };
    
    const inboundPattern = valuesCopy?.FIELDTYPE === "DATE" ? valuesCopy?.PATTERN : null;
    
    if (valuesCopy.hasOwnProperty("FIELDTYPE")) delete valuesCopy.FIELDTYPE;
    if (valuesCopy.hasOwnProperty("ACTION")) delete valuesCopy.ACTION;
    if (valuesCopy.hasOwnProperty("INDEX")) delete valuesCopy.INDEX;
    
    const sourceOnlyProps = {
      ...(valuesCopy.PARENT && { PARENT: valuesCopy.PARENT }),
      ...(valuesCopy.MAPNAME && { MAPNAME: valuesCopy.MAPNAME }),
      ...(valuesCopy.RECORD_TYPE && { RECORD_TYPE: valuesCopy.RECORD_TYPE }),
      ...(valuesCopy.CUSTOM_DB_FIELD && { CUSTOM_DB_FIELD: valuesCopy.CUSTOM_DB_FIELD }),
      ...(valuesCopy.PLUGIN_NAME && { PLUGIN_NAME: valuesCopy.PLUGIN_NAME }),
      ...(valuesCopy.WF_ITEM_ID && { WF_ITEM_ID: valuesCopy.WF_ITEM_ID }),
      ...(valuesCopy.WF_ITEM_LOCATION && { WF_ITEM_LOCATION: valuesCopy.WF_ITEM_LOCATION }),
      ...(valuesCopy.MAP_REPETITION_INDEX && { MAP_REPETITION_INDEX: valuesCopy.MAP_REPETITION_INDEX }),
      ...(valuesCopy.SOURCE_REPEATING_FIELD && { SOURCE_REPEATING_FIELD: valuesCopy.SOURCE_REPEATING_FIELD }),
      // Only include INBOUND_PATTERN if it's a DATE field, not the internal isDateMapped flag
      ...(inboundPattern && { INBOUND_PATTERN: inboundPattern }),
      ...(sourceType && { SOURCE_TYPE: sourceType }),
    };
		
		submitActionHandler(null, null, sourceOnlyProps);
	};
  const formattingOptionsHandler = (prop,newVal,bulk) => {
    debounceActionHandler(prop,newVal,bulk)
  }
  const workflowSessionValueHandler = ([values]) => {
    let { MAPNAME, WF_ITEM_ID, WF_ITEM_LOCATION } = values;

    MAPNAME = MAPNAME.startsWith("Variable:")
      ? MAPNAME.split(":")[1].trim()
      : MAPNAME;

    setSessionItemValue(MAPNAME);

    const bulk = {
      SET_INDEXTYPE: MAPNAME,
      WF_ITEM_ID,
      WF_ITEM_LOCATION,
    };

    debounceActionHandler(null, null, bulk);
  };

  return (
    <>
      {/* Variable collection info */}
      <Stack spacing={"15px"} className="tp-segment">
        <Autocomplete
          size="small"
          variant="outlined"
          freeSolo
          className="width-100"
          options={variableNameOptions}
          value={variableName}
          inputValue={variableName}
          onBlur={() => {
            if (!variableName) setVariableName(t("VCUNNAMED"));
          }}
          onChange={(e) => {
            setVariableName(e.target.value || "");
            debounceChangeHandler("NAME", e.target.value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              onChange={(e) => {
                const value = e.target.value ? e.target.value : t("VCUNNAMED");
                setVariableName(e.target.value);
                debounceChangeHandler("NAME", `${value}`);
              }}
              autoComplete="off"
              label={t("LBL_VAR_NAME")}
            />
          )}
        />
        <FormControl variant="outlined" className="width-100" size="small">
          <TextField
            size="small"
            label={t("LBL_INIT_VAL")}
            autoComplete="off"
            value={initialValue}
            onChange={(e) => {
              setInitialValue(e.target.value);
              debounceChangeHandler("START_VALUE", e.target.value);
            }}
          />
        </FormControl>
        <FormControl>
          <div className="flex">
            <TPCheckbox
              label={t("BTN_ADD_TO_WF_SESSION")}
              checked={workflowSession}
              handleCheck={(checked) => {
                setWorkflowSession(checked);
                if (!workflowSessionValue || !selectedNode?.WF_SESSION_NAME) {
                  const value = workflowSessionValue
                    ? workflowSessionValue
                    : variableName;
                  setWorkflowSessionValue(value);
                  debounceChangeHandler("WF_SESSION_NAME", value);
                  if (!checked) debounceChangeHandler("WF_SESSION_NAME", "");
                }
              }}
            />
            <TextField
              size="small"
              value={workflowSessionValue}
              style={{ flex: 1 }}
              disabled={!workflowSession}
              label={t("LBL_WORKFLOW_SESSION_VAL")}
              className={"width-100"}
              autoComplete="off"
              onChange={(e) => {
                setWorkflowSessionValue(e.target.value);
                debounceChangeHandler("WF_SESSION_NAME", e.target.value);
              }}
            />
          </div>
        </FormControl>

        <FormControl
          variant="outlined"
          className="width-100"
          size="small"
          style={{ marginTop: "0px" }}>
          <TPCheckbox
            label={t("BTN_APPLY_FIELD_PROPERTIES")}
            checked={applyToFldProperties}
            handleCheck={(checked) => {
              setApplyToFldProperties(checked);
              debounceChangeHandler("FORMAT_WFSESSION_VAR", checked);
            }}
            disabled={!workflowSession}
          />
        </FormControl>
      </Stack>
      {/* variable actions */}
      <Accordion sx={styles.accordianContainer} defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="accordianDataSource"
          className="accordian-override"
          id="accordianDataSource"
          sx={styles.accordianHeader}>
          <SectionHeader text={t("LBL_VAR_ACTIONS")} />
        </AccordionSummary>
        <AccordionDetails sx={styles.accordianContainer}>
          <Stack spacing={"15px"} className="tp-segment">
            <ResizableBox>
              <CommonGrid
                rowData={rowData}
                gridOptions={gridOptions}
                onGridReady={onGridReady}
                getGridAPI={(e, gridRef) => {
                  setGridApi(gridRef.api);
                  variableActionsHandler(selectedNode?.VARIABLE || [], 0);
                }}
                containerStyle={{ height: "100% !important" }}
                gridResizable={true}
                gridProps={{
                  onRowClicked: handleRowClicked,
                  overlayNoRowsTemplate: t("NO_DATA_MSSG_VARIABLE_ACTION"),
                }}
              />
            </ResizableBox>

            {/* </div> */}
            <FormControl variant="outlined" className="width-100" size="small">
              <InputLabel id="VADropdownLabel">
                {t("LBL_VAR_ACTION")}
              </InputLabel>
              <Select
                className={"width-100"}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 300,
                    },
                  },
                }}
                name={"VA"}
                value={variableAction}
                labelId="VADropdownLabel"
                label={t("LBL_VAR_ACTION")}
                id="VADropdown"
                onChange={handleVaribleActionChange}>
                {variableActionOptionsDropdown}
              </Select>
            </FormControl>
            {!actionWithoutControl.includes(variableAction) &&
              !["SORT","SORT_UNIQUE"].includes(variableAction) && (
                <FormControl
                  variant="outlined"
                  className="width-100"
                  size="small">
                  <InputLabel id="indexDropdownLabel">
                    {t("LBL_INDEX")}
                  </InputLabel>
                  <Select
                    className={"width-100"}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 300,
                        },
                      },
                    }}
                    name={"INDEX"}
                    value={indexOption}
                    labelId="indexDropdownLabel"
                    label={t("LBL_INDEX")}
                    id="indexDropdown"
                    onChange={(e) => {
                      setIndexOption(e.target.value);
                      actionUpdater("SET_INDEX", e.target.value);
                    }}>
                    {indexOptionsDropdown}
                  </Select>
                </FormControl>
              )}

            {(variableAction === "SORT" || variableAction === "SORT_UNIQUE") && (
              <VariableActionSortRenderer
                variableActionNode={actionselectedNode}
                submitChange={actionUpdater}
              />
            )}
            {variableAction === 'UNIQUE' && (
              <FormControl variant="outlined" className="width-100" size="small">
              <TPCheckbox
                label={t("BTN_IGNORE_CASE")}
                checked={ignoreCase}
                handleCheck={(checked) => {
                  setIgnoreCase(checked);
                  actionUpdater(null,null,{IGNORE_CASE:checked ? "TRUE":"FALSE"})
                }}
              />
            </FormControl>
            )}
            {indexOption === "FILL" && (
              <FormControl
                variant="outlined"
                className="width-100"
                size="small">
                <div className="flex">
                  <Autocomplete
                    freeSolo
                    className={"width-100"}
                    size="small"
                    options={delimiterOptions}
                    // value={delimiterOptions?.length ? delimiterValue : ""}
                    value={delimiterValue}
                    onChange={(e, newValue) => {
                      setDelimiterValue(newValue);
                      debounceActionHandler("SET_INDEXTYPE", newValue);
                    }}
                    onInputChange={(event, newInputValue) => {
                      debounceActionHandler("SET_INDEXTYPE", newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("LBL_FILL_DELIM")}
                        // value={delimiterOptions?.length ? delimiterValue : ""}
                        value={delimiterValue}
                        autoComplete="off"
                        onChange={(e) => {
                          setDelimiterValue(e.target.value);
                          debounceActionHandler(
                            "SET_INDEXTYPE",
                            e.target.value
                          );
                        }}
                      />
                    )}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    disableElevation
                    className="margin-left-4"
                    sx={{
                      width: "40px",
                      padding: "4px 8px",
                      minWidth: "40px",
                    }}
                    onClick={handleDelimiterModalState}>
                    <MoreHorizIcon fontSize="small" />
                  </Button>
                </div>
              </FormControl>
            )}
            {openDelimiterModal && (
              <DelimiterDialog
                modalOpen={openDelimiterModal}
                close={() => setOpenDelimiterModal(false)}
                val={delimiterValue}
                handleInput={handleDelimitedInput}
                name="SET_INDEXTYPE"
                from="VC properties"
              />
            )}
            {indexOption === "VARIABLE" && (
              <FormControl
                variant="outlined"
                className="width-100"
                size="small">
                <Autocomplete
                  freeSolo
                  className={"width-100"}
                  size="small"
                  options={variableOptions}
                  value={variableOptions?.length ? variableValue : ""}
                  onChange={(e, newValue) => {
                    setVariableValue(newValue);
                    debounceActionHandler("SET_INDEXTYPE", newValue.label);
                  }}
                  renderOption={(props, option) => {
                    return (
                      <li {...props} key={option.key}>
                        {option.label}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("LBL_VAR_NAME")}
                      value={variableOptions?.length ? variableValue : ""}
                      autoComplete="off"
                      onChange={(e) => {
                        setVariableValue(e.target.value);
                        debounceActionHandler("SET_INDEXTYPE",e.target.value);
                      }}
                    />
                  )}
                />
              </FormControl>
            )}
            {indexOption === "SESSION_DATA" && (
              <FormControl
                variant="outlined"
                className="width-100"
                size="small">
                <div className="flex">
                  <Autocomplete
                    freeSolo
                    className={"width-100"}
                    size="small"
                    options={sessionItemOptions}
                    value={sessionItemOptions?.length ? sessionItemValue : ""}
                    onChange={(e, newValue) => {
                      setSessionItemValue(newValue);
                      debounceActionHandler("SET_INDEXTYPE", newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("LBL_SESSION_DATA_ITEM")}
                        value={
                          sessionItemOptions?.length ? sessionItemValue : ""
                        }
                        autoComplete="off"
                        onChange={(e) => {
                          setSessionItemValue(e.target.value);
                          debounceActionHandler(
                            "SET_INDEXTYPE",
                            e.target.value
                          );
                        }}
                      />
                    )}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    disableElevation
                    className="margin-left-4"
                    sx={{
                      width: "40px",
                      padding: "4px 8px",
                      minWidth: "40px",
                    }}
                    onClick={() => setOpenWorkflowSessionModal(true)}>
                    <MoreHorizIcon fontSize="small" />
                  </Button>
                </div>
              </FormControl>
            )}
             <WorkflowSessionModal1
                sourceType={'callingWorkflow'}
                openModal={openWorkflowSessionModal}
                handleClose={setOpenWorkflowSessionModal}
                valueHandler={workflowSessionValueHandler}
                selection={"single"}
              />
            {variableAction === "COUNT" && (
              <VariableActionCountRenderer
                variableActionNode={actionselectedNode}
                submitChange={actionUpdater}
              />
            )}
            {/* Field type dropdown */}
            {actionsWithFieldTypes.includes(variableAction) ? (
              variableAction === "SET" || variableAction === "CONCATENATE" || variableAction === 'PRETTY_PRINT_XML' || variableAction === 'DE_IDENTIFY' ? (
                <FormControl
                  variant="outlined"
                  className="width-100"
                  size="small">
                  <InputLabel>{t("LBL_FIELD_TYPE")}</InputLabel>
                  <Select
                    variant="outlined"
                    size="small"
                    className={"width-100"}
                    value={fieldType}
                    onChange={(e) => {
                      setFieldType(e.target.value);
                      debounceActionHandler("FIELDTYPE", e.target.value);
                    }}>
                    {fieldTypeOptions[variableAction].map(
                      (fieldType, index) => (
                        <MenuItem key={index} value={fieldType}>
                          {t(fieldType)}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              ) : (
                <FormControl
                  variant="outlined"
                  className="width-100"
                  size="small">
                  <InputLabel>{t("LBL_FIELD_TYPE")}</InputLabel>
                  <Select
                    variant="outlined"
                    size="small"
                    className={"width-100"}
                    value={fieldType}
                    onChange={(e) => {
                      setFieldType(e.target.value);
                      debounceActionHandler("FIELDTYPE", e.target.value);
                    }}>
                    {fieldTypeOptions.OTHERS.map((fieldType, index) => (
                      <MenuItem key={index} value={fieldType}>
                        {t(fieldType)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )
            ) : (
              ""
            )}
            {variableAction === "SET" && fieldType === "BIT_FLAG" && (
              <FieldTypeByte
                variableActionNode={actionselectedNode}
                submitChange={actionUpdater}
              />
            )}
            {fieldType === "CONSTANT" && (
              <>
                <ConstantValueControl
                  constantValueOptions={constantValueOptions}
                  constantValue={constantValue}
                  setConstantValue={(value) => {
                    setConstantValue(value);
                    debounceActionHandler("VALUE", value);
                  }}
                />
                {dateInterval ? (
                  <FormControl className="width-100" size="small">
                    <InputLabel id="dateInterval">
                      {t("LBL_DATE_INTERVAL")}
                    </InputLabel>
                    <Select
                      variant="outlined"
                      size="small"
                      className={"width-100"}
                      value={dateIntervalValue}
                      onChange={(e) => {
                        setDateIntervalValue(e.target.value);
                        debounceActionHandler("UNIT", e.target.value);
                      }}>
                      {dateIntervalOptions}
                    </Select>
                  </FormControl>
                ) : (
                  <TextField
                    id="fieldRepeatNum"
                    size="small"
                    variant="outlined"
                    label={t("LBL_REPEAT_#_TIMES")}
                    autoComplete="off"
                    value={repeatNumValue}
                    onChange={(e) => {
                      handleRepeatTimesChange(e.target.value);
                    }}
                  />
                )}
              </>
            )}
          </Stack>
        </AccordionDetails>
      </Accordion>
      {/* Data Source Section*/}
      {[
        "ALPHA",
        "DATE",
        "FLOAT",
        "INTEGER",
        "PACKED_INT",
        "ZONED_INT",
      ].includes(fieldType) &&
        actionsWithFieldTypes.includes(variableAction) && (
          <Accordion sx={styles.accordianContainer} defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="accordianFieldInfo"
              className="accordian-override"
              id="accordianDataSource"
              sx={styles.accordianHeader}>
              <SectionHeader text={t("LBL_DATA_SOURCE")} />
            </AccordionSummary>
            <AccordionDetails sx={styles.accordianContainer}>
              <SourceType
                node={{
                  PARENT: actionselectedNode?.PARENT,
                  MAPNAME: actionselectedNode?.MAPNAME,
                  RECORD_TYPE: actionselectedNode?.RECORD_TYPE,
                  ACTION: actionselectedNode?.VARIABLE_COLLECTION_ACTION,
                  INDEX: actionselectedNode?.VARIABLE_COLLECTION_INDEX,
                  CUSTOM_DB_FIELD: actionselectedNode?.CUSTOM_DB_FIELD,
                  PLUGIN_NAME: actionselectedNode?.PLUGIN_NAME,
                  key: actionselectedNode?.id,
                  PATTERN: actionselectedNode?.PATTERN,
                  PRECISION: actionselectedNode?.PRECISION,
                  MAP_REPETITION_INDEX: actionselectedNode?.MAP_REPETITION_INDEX,
                }}
                initialSelectCall={true}
                valuesHandler={sourceTypeValuesHandler}></SourceType>
            </AccordionDetails>
          </Accordion>
        )}
      {/* Formatting options and advance properties */}
      {[
        "ALPHA",
        "DATE",
        "FLOAT",
        "INTEGER",
        "PACKED_INT",
        "ZONED_INT",
      ].includes(fieldType) &&
        actionsWithFieldTypes.includes(variableAction) && (
          <>
            <Accordion sx={styles.accordianContainer} defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="accordianFieldInfo"
                className="accordian-override"
                id="accordianDataSource"
                sx={styles.accordianHeader}>
                <SectionHeader text={t("LBL_FORMATE_OPTIONS")} />
              </AccordionSummary>
              <AccordionDetails sx={styles.accordianContainer}>
                <FormattingOptions
                  node={actionselectedNode}
                  valueshandler={formattingOptionsHandler}
                  callerComponent={"VCProperties"}
                  showDateInterval={dateInterval}
                  isDateMapped={actionselectedNode?.FIELDTYPE === "DATE"}
                />
              </AccordionDetails>
            </Accordion>
          </>
        )}
    </>
  );
}

export default OutboundVariableCollectionProperties;

const styles = {
  fpContainer: {
    // padding: "0 16px 16px 16px"
    padding: "0 4px 4px 4px",
  },
  accordianContainer: {
    border: "none",
    padding: "0",
    margin: "0",
    boxShadow: "none",
    backgroundColor: "unset",
  },
  accordianHeader: {
    border: "none",
    padding: "0",
    margin: "0",
    backgroundColor: "unset",
  },
  accordianContent: {
    border: "none",
    padding: "0 15px",
    margin: "0",
    backgroundColor: "unset",
  },
};
const actionsWithFieldTypes = [
  "SET",
  "CONCATENATE",
  "ADD",
  "SUBTRACT",
  "MULTIPLY",
  "DIVIDE",
  "ABS",
  "ACOS",
  "ACRE_TO_HECTARE",
  "DATE_DIFF",
  "ACRE_TO_SQMETER",
  "ASCII_TO_ENCODE_HEX",
  "ASIN",
  "BASE64_TO STRING",
  "BASE64URL_TO_STRING",
  "CEILING",
  "CENTIMETER_TO_INCHES",
  "CELSIUS_TO_FAHRENHEIT",
  "NUMBER_TO_CHAR",
  "COS",
  "CUBICFEET_TO_CUBICMETER",
  "CUBICINCHES_TO_LITERS",
  "CUBICMETER_TO_CUBICFEET",
  "CUBICMETER_TO_CUBICYARD",
  "CUBICYARD_TO_CUBICMETER",
  "CUBICMETER_TO_GALLON",
  "ENCODE_HEX_TO_ASCII",
  "POWER",
  "QUARTS_TO_LITERS",
  "ROUND",
  "ROUND_DOWN",
  "ROUND_UP",
  "SIGN",
  "SIN",
  "SQCENTIMETER_TO_SQINCHES",
  "SQFEET_TO_SQMETER",
  "SQINCHES_TO_SQCENTIMETER",
  "SQMETER_TO_ACRE",
  "SQMETER_TO_SQFEET",
  "SQMETERS_TO_SQYARDS",
  "SQRT",
  "SQYARDS_TO_SQMETERS",
  "STRING_LENGTH",
  "STRING_TO_BASE64",
  "STRING_TO_BASE64URL",
  "TAN",
  "TANH",
  "TO_DEGREE",
  "TO_RADIAN",
  "YARDS_TO_METERS",
  "URLDECODE",
  "URLENCODE",
  "XML_TO_JSON",
  "PRETTY_PRINT_XML",
  "DE_IDENTIFY"
];

const actionWithoutControl = [
  "REVERSE",
  "RESET",
  "ESCAPE_XML_DATA",
  "FAHRENHEIT_TO_CELSIUS",
  "FEET_TO_METERS",
  "FLOOR",
  "GALLON_TO_CUBICMETER",
  "GRAMS_TO_OUNCES",
  "HECTARE_TO_ACRE",
  "HEXADECIMAL",
  "HEX_TO_DECIMAL",
  "INCHES_TO_CENTIMETER",
  "INCHES_TO_MM",
  "KG_TO_LBS",
  "KM_TO_MILES",
  "LBS_TO_KG",
  "LITERS_TO_CUBICINCHES",
  "LITERS_TO_QUARTS",
  "LOG",
  "LOG_10",
  "METERS_TO_FEET",
  "METERS_TO_YARDS",
  "MILES_TO_KM",
  "MM_TO_INCHES",
  "MODULUS",
  "OCTAL",
  "OUNCES_TO_GRAMS",
  "UNIQUE"
];

const fieldTypeOptions = {
  SET: [
    "SELECT",
    "ALPHA",
    "BIT_FLAG",
    "CONSTANT",
    "DATE",
    "FLOAT",
    "INTEGER",
    "PACKED_INT",
    "ZONED_INT",
  ],
  CONCATENATE :  [
    "SELECT",
    "ALPHA",
    "CONSTANT",
    "DATE",
    "FLOAT",
    "INTEGER",
    "PACKED_INT",
    "ZONED_INT",
  ],
  DE_IDENTIFY: [
    "SELECT",
    "ALPHA",
    "BIT_FLAG",
    "CONSTANT",
    "DATE",
    "FLOAT",
    "INTEGER",
    "PACKED_INT",
    "ZONED_INT",
  ],
  PRETTY_PRINT_XML: [
    "SELECT",
    "ALPHA",
    "BIT_FLAG",
    "CONSTANT",
    "DATE",
    "FLOAT",
    "INTEGER",
    "PACKED_INT",
    "ZONED_INT",
  ],
  OTHERS:  [
    "SELECT",
    "CONSTANT",
    "FLOAT",
    "INTEGER",
    "PACKED_INT",
    "ZONED_INT",
  ],
};